import { Component, Input, SimpleChanges } from '@angular/core';
import {
  filterZeroValuesForChart,
  getRandomColorWithOpacity,
  wrapLabel,
  yAxisformateValue,
} from '@piqet-angular/data';
import { commonEnum, reportTitals } from '@piqet-angular/shared';
import { bottom } from '@popperjs/core';
import { Chart, ChartOptions } from 'chart.js';

@Component({
  selector: 'piqet-angular-report-bar-chart-component',
  templateUrl: './report-bar-chart-component.component.html',
  styleUrls: ['./report-bar-chart-component.component.scss'],
})
export class ReportBarChartComponentComponent {
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';

  @Input() impactItems: any;
  chartId: any;
  reportResource = reportTitals;
  componentItemsArray: any;
  componentItemsArrayForChart: any[] = [];

  @Input() isIsoReport = false;

  ngOnChanges(changes: SimpleChanges) {
    this.impactItems = changes['impactItems']?.currentValue;
    this.chartId = 'BarChartContainer' + this.impactItems.reportTypeId;
    if (this.impactItems?.componentItems?.length > 0) {
      ['Product filling and distribution', 'Total'].forEach(name => {
        let index = this.impactItems.componentItems.findIndex((item: any) => item.name === name);
        if (index > -1) {
          this.impactItems.componentItems.push(this.impactItems.componentItems.splice(index, 1)[0]);
        }
      });
    }

    this.componentItemsArray = this.impactItems.componentItems;
    this.chartOpacity = { value: this.impactItems?.opacity };
    this.indicatorsName = this.impactItems?.indicatorName;
    this.componentItemsArrayForChart = filterZeroValuesForChart(this.componentItemsArray);
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }
}
